/**
 * Shared segments in the command bar, kept out of CommandBar.tsx so the bar
 * itself only gains two lines.
 *
 * Each row's id is `shared:<id>`, so the bar's `segment:` prefix makes it
 * `segment:shared:<id>` and `routeFor` opens `/leads?segment=shared:<id>`,
 * the same address the Segments page uses. Private tabs keep their numeric
 * ids, so nothing a person already has in Recent changes meaning.
 */
import { sharedKey, type SharedSegment } from '../api/queries';

export { useSharedSegments } from '../api/queries';

export function sharedSegmentRows(segments: SharedSegment[] | undefined) {
  return (segments ?? []).map((s) => ({
    id: sharedKey(s.id),
    label: s.name,
    description: s.is_owner ? 'Shared by you' : `Shared by ${s.owner_name}`,
  }));
}
